import styled from 'styled-components';

export const StoreCardListWrapper = styled.div`
  height: 100%;
`;

export const StoreCardWrapper = styled.div`
  border: 1px solid ${p => p.theme.token('border-color-default')};
`;
